const time = new Intl.RelativeTimeFormat('en');

// in milliseconds
const units: { [key: string]: number } = {
  year: 24 * 60 * 60 * 1000 * 365,
  month: (24 * 60 * 60 * 1000 * 365) / 12,
  day: 24 * 60 * 60 * 1000,
  hour: 60 * 60 * 1000,
  minute: 60 * 1000,
  second: 1000,
};

export function getRelativeTime(dateTime: Date, dateTimeComparer = new Date()) {
  const elapsed = +dateTime - +dateTimeComparer;

  // "Math.abs" accounts for both "past" & "future" scenarios
  for (let unit in units) {
    if (Math.abs(elapsed) > units[unit]) {
      return time.format(
        Math.round(elapsed / units[unit]),
        <Intl.RelativeTimeFormatUnit>unit
      );
    }
  }

  return 'right now';
}

export function getElapsedTime(startDate: Date, endDate: Date): string {
  const elapsed = Math.abs(+endDate - +startDate);

  for (let unit in units) {
    if (elapsed > units[unit]) {
      const value = Math.floor(elapsed / units[unit]);
      return `${value} ${unit}${value > 1 ? 's' : ''}`;
    }
  }

  return '-';
}

export function getElapsedMilliseconds(start: Date, end: Date): number {
  return Math.abs(end.getTime() - start.getTime());
}

export function formatAverageDuration(ms: number): string {
  for (const unit in units) {
    const unitMs = units[unit];
    if (ms >= unitMs) {
      const value = Math.floor(ms / unitMs);
      return `${value} ${unit}${value > 1 ? 's' : ''}`;
    }
  }
  return '0 seconds';
}
